import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import ScrollToTop from './components/ScrollToTop';

// Import pages
import Home from './components/pages/Home';
import About from './components/pages/About';
import Services from './components/pages/Services';
import Retainership from './components/pages/Retainership';
import FAQ from './components/pages/FAQ';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Contact from './components/pages/Contact';

// Import layout components
import HomeLayout from './components/HomeLayout';
import PageLayout from './components/PageLayout';



// AnimatePresence wrapper component
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Home page with slider */}
        <Route path="/" element={
          <HomeLayout>
            <PageTransition>
              <Home />
            </PageTransition>
          </HomeLayout>
        } />
        
        {/* Other pages without slider */}
        <Route path="/about" element={
          <PageLayout>
            <PageTransition>
              <About />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="/services" element={
          <PageLayout>
            <PageTransition>
              <Services />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="/retainership" element={
          <PageLayout>
            <PageTransition>
              <Retainership />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="/faq" element={
          <PageLayout>
            <PageTransition>
              <FAQ />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="/privacy" element={
          <PageLayout>
            <PageTransition>
              <PrivacyPolicy />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="/contact" element={
          <PageLayout>
            <PageTransition>
              <Contact />
            </PageTransition>
          </PageLayout>
        } />
        <Route path="*" element={<PageLayout><Navigate to="/" replace /></PageLayout>} />
      </Routes>
    </AnimatePresence>
  );
};

// Page transition wrapper
const PageTransition = ({ children }: { children: React.ReactNode }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
